import React from 'react';
import Grid from "@mui/material/Unstable_Grid2";
import {AccordionDetails, Box, Typography} from "@mui/material";
import {AccordionData} from "../../interfaces/AccordionData";

interface IProps {
    data: AccordionData[]
}

export default function AccordionDetailsInfo({data}: IProps) {

    return (
        <AccordionDetails>
            <Grid container spacing={1}>
                {data.map(field => {
                    return (
                        <Grid
                            xs={field.size}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}>
                                <Typography sx={{
                                    color: "secondary.dark"

                                }}>
                                    {field.label}:
                                </Typography>
                                <Typography sx={{
                                    paddingRight: '3rem',
                                    whiteSpace: "pre-wrap"
                                }}>
                                    {field.value} </Typography>
                            </Box>
                        </Grid>
                    );

                })}
            </Grid>
        </AccordionDetails>
    );
}